
<!--start header-->

<header class="head d-flex justify-content-center align-items-center">

  <div class="head-caption text-center">
   <h1>RECIPIES</h1>
   <p>Read our Story, How we started and about the Team</p>
  </div>

</header>

<!--end header-->

<!-- start section recipe-->

<section class="container py-5 recipe">
  <div class="row">

   <div class="col-lg-3 col-md-6 mb-5">
     
       <img src="assets/images/1.jpg" class="img-fluid " alt="food">
   </div>   
   <div class="col-lg-3 col-md-6 mb-5"> 
       <div class="ml-5 recipe-content">
         <h4>RECIPE NAME HERE</h4>
         <div class="mb-2">
           <span class="fas fa-star mr-1"></span>
           <span class="fas fa-star active1 mr-1"></span>
           <span class="fas fa-star active1 mr-1"></span>
           <span class="fas fa-star active1 mr-1"></span>
           <span class="fas fa-star active1 mr-1"></span>
         </div>
         <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
           typesetting industry. <br> Lorem Ipsum has been the industry's standard.
         </p>
         <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
       </div>
   </div>
   <div class="col-lg-3 col-md-6 mb-5">
     
    <img src="assets/images/2.jpg" class="img-fluid " alt="food">
</div>   
<div class="col-lg-3 col-md-6 mb-5"> 
    <div class="ml-5 recipe-content">
      <h4>RECIPE NAME HERE</h4>
      <div class="mb-2">
        <span class="fas fa-star mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
      </div>
      <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
        typesetting industry. <br> Lorem Ipsum has been the industry's standard.
      </p>
      <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
    </div>
</div>
   
<hr class="w-100">
<div class="col-lg-3 col-md-6 mb-5">
     
  <img src="assets/images/6.jpg" class="img-fluid " alt="food">
</div>   
<div class="col-lg-3 col-md-6 mb-5"> 
  <div class="ml-5 recipe-content">
    <h4>RECIPE NAME HERE</h4>
    <div class="mb-2">
      <span class="fas fa-star mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
    </div>
    <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
      typesetting industry. <br> Lorem Ipsum has been the industry's standard.
    </p>
    <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
  </div>
</div>
<div class="col-lg-3 col-md-6 mb-5">

<img src="assets/images/5.jpg" class="img-fluid " alt="food">
</div>   
<div class="col-lg-3 col-md-6 mb-5"> 
<div class="ml-5 recipe-content">
 <h4>RECIPE NAME HERE</h4>
 <div class="mb-2">
   <span class="fas fa-star mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
 </div>
 <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
   typesetting industry. <br> Lorem Ipsum has been the industry's standard.
 </p>
 <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
</div>
</div>

<hr class="w-100">
<div class="col-lg-3 col-md-6 mb-5">
     
  <img src="assets/images/99.jpg" class="img-fluid " alt="food">
</div>   
<div class="col-lg-3 col-md-6 mb-5"> 
  <div class="ml-5 recipe-content">
    <h4>RECIPE NAME HERE</h4>
    <div class="mb-2">
      <span class="fas fa-star mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
      <span class="fas fa-star active1 mr-1"></span>
    </div>
    <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
      typesetting industry. <br> Lorem Ipsum has been the industry's standard.
    </p>
    <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
  </div>
</div>
<div class="col-lg-3 col-md-6 mb-5">

<img src="assets/images/3.jpg" class="img-fluid " alt="food">
</div>   
<div class="col-lg-3 col-md-6 mb-5"> 
<div class="ml-5 recipe-content">
 <h4>RECIPE NAME HERE</h4>
 <div class="mb-2">
   <span class="fas fa-star mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
   <span class="fas fa-star active1 mr-1"></span>
 </div>
 <p>Lorem Ipsum is simply <br> dummy text of the printing <br> and 
   typesetting industry. <br> Lorem Ipsum has been the industry's standard.
 </p>
 <button class=" org text-dark btn-default border-0 p-3 mt-2">VIEW DETAILS</button>
</div>
</div>

<hr class="w-100">
  
  
  </div>
</section>

<!-- end section recipe-->

<!-- start section features-->

<section class="py-5 features">
  <div class="container">
    <h5 class="pb-3 title">FEATURED RECIPE</h5>
      <div data-slick='{"slidesToShow": 4, "slidesToScroll": 1}' class="feature">
              
                  
          <div class="testimonial-caption mr-2">
              <img src="assets/images/a.jpg" class="img-fluid pb-3" alt="">
              <h5>FOOD NAME</h5>
              <div class="mb-2">
                <span class="fas fa-star mr-1"></span>
                <span class="fas fa-star active1 mr-1"></span>
                <span class="fas fa-star active1 mr-1"></span>
                <span class="fas fa-star active1 mr-1"></span>
                <span class="fas fa-star active1 mr-1"></span>
              </div>
              
          </div>
          <div class="testimonial-caption mr">
            <img src="assets/images/b.jpg" class="img-fluid pb-3" alt="">
            <h5>FOOD NAME</h5>
            <div class="mb-2">
              <span class="fas fa-star mr-1"></span>
              <span class="fas fa-star active1 mr-1"></span>
              <span class="fas fa-star active1 mr-1"></span>
              <span class="fas fa-star active1 mr-1"></span>
              <span class="fas fa-star active1 mr-1"></span>
            </div>
            
        </div>
        <div class="testimonial-caption mr-2">
          <img src="assets/images/c.jpg" class="img-fluid pb-3" alt="">
          <h5>FOOD NAME</h5>
          <div class="mb-2">
            <span class="fas fa-star mr-1"></span>
            <span class="fas fa-star active1 mr-1"></span>
            <span class="fas fa-star active1 mr-1"></span>
            <span class="fas fa-star active1 mr-1"></span>
            <span class="fas fa-star active1 mr-1"></span>
          </div>
          
      </div>
      <div class="testimonial-caption mr-2">
        <img src="assets/images/d.jpg" class="img-fluid pb-3" alt="">
        <h5>FOOD NAME</h5>
        <div class="mb-2">
          <span class="fas fa-star mr-1"></span>
          <span class="fas fa-star active1 mr-1"></span>
          <span class="fas fa-star active1 mr-1"></span>
          <span class="fas fa-star active1 mr-1"></span>
          <span class="fas fa-star active1 mr-1"></span>
        </div>
        
    </div>
    <div class="testimonial-caption mr-2">
      <img src="assets/images/b.jpg" class="img-fluid pb-3" alt="">
      <h5>FOOD NAME</h5>
      <div class="mb-2">
        <span class="fas fa-star mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
        <span class="fas fa-star active1 mr-1"></span>
      </div>
      
  </div>
  
          
      </div>
  </div>
</section>


<!-- end section features-->

<!--start section insta-->

<section class="bg">

  <div class="container py-4">

   <div class="row insta-caption">
      <div class="col-md-3 sub-caption">
          <p>SUBSCRIBE</p>
      </div>
      <div class="col-md-8">
       <p class="text-muted p">Get updates about new dishes and upcoming events</p>
   </div>
     
     </div>
     <div class="registers d-flex justify-content-end pb-4">
       <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
       <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
     </div>

  </div>
</section>

<!--end section insta-->